const RULES = [
  [/\b(founder|entrepreneur|EIR|entrepreneurship|buying a business)\b/i, 'Founder'],
  [/\b(product design|ux design|growth design)\b/i, 'Design'],
  [/\b(product marketing|PMM)\b/i, 'Marketing'],
  [/\b(venture capital|VC|angel invest|investment banking|corporate finance|development finance)\b/i, 'Finance'],
  [/\b(data science|data journalism|data analytics)\b|data.*interview prep|interview prep.*data/i, 'Data'],
  [/\b(product management|product manager|PM in|journey to PM|offering manager)\b/i, 'Product'],
  [/\b(brand|public relations|PR manager|b2b marketing|consumer insights|marketing analytics|retail category)\b/i, 'Marketing'],
  [/\b(management consulting|chief[ -]?of[ -]?staff|business strategy|strategy[ &](and|&)? ?planning)\b/i, 'Strategy'],
  [/\b(growth manager|head of growth|growth)\b/i, 'Growth'],
  [/\b(sales|business development|biz dev|customer success|partnerships)\b/i, 'Sales'],
  [/\b(ux research|user research|market research)\b/i, 'Research'],
];

export default function extractRole(title) {
  if (!title) return null;
  const match = RULES.find(([re]) => re.test(title));
  return match ? match[1] : null;
}
